import importAssets from 'helper/import-assets';
import type { CustomImages } from 'ui/assets/images/types';

export default importAssets(require.context('./files/', false, /\.\/.*\.png$/)) as CustomImages;
